// Get from: https://valorant-api.com/v1/agents?isPlayableCharacter=true
export const AGENTS = [
  {
    uuid: "dade69b4-4f5a-8528-247b-219e5a1facd6",
    displayName: "Fade",
    description:
      "Turkish bounty hunter Fade unleashes the power of raw nightmare to seize enemy secrets. Attuned with terror itself, she hunts down targets and reveals their deepest fears - before crushing them in the dark.",
    developerName: "BountyHunter",
    characterTags: null,
    displayIcon:
      "https://media.valorant-api.com/agents/dade69b4-4f5a-8528-247b-219e5a1facd6/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/dade69b4-4f5a-8528-247b-219e5a1facd6/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/dade69b4-4f5a-8528-247b-219e5a1facd6/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/dade69b4-4f5a-8528-247b-219e5a1facd6/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/dade69b4-4f5a-8528-247b-219e5a1facd6/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/dade69b4-4f5a-8528-247b-219e5a1facd6/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/dade69b4-4f5a-8528-247b-219e5a1facd6/background.png",
    backgroundGradientColors: ["b1414cff", "5589bdff", "18344cff", "66376cff"],
    assetPath:
      "ShooterGame/Content/Characters/BountyHunter/BountyHunter_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "1b47567f-8f7b-444b-aae3-b0c634622d10",
      displayName: "Initiator",
      description:
        "Initiators challenge angles by setting up their team to enter contested ground and push defenders away.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/1b47567f-8f7b-444b-aae3-b0c634622d10/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Breaker_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Seize",
        description:
          "EQUIP a knot of raw fear. FIRE to throw. The knot drops down after a set time. RE-USE to drop the knot early. The knot ruptures on impact, holding nearby enemies in place. Held enemies are deafened, and decayed.",
        displayIcon:
          "https://media.valorant-api.com/agents/dade69b4-4f5a-8528-247b-219e5a1facd6/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Haunt",
        description:
          "EQUIP a haunting watcher. FIRE to throw. The watcher drops down after a set time. RE-USE to drop the watcher early. The watcher lashes out on impact, revealing enemies in its line of sight and creating terror trails to them. Enemies can destroy the watcher.",
        displayIcon:
          "https://media.valorant-api.com/agents/dade69b4-4f5a-8528-247b-219e5a1facd6/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Prowler",
        description:
          "EQUIP a prowler. FIRE to send the prowler forward. HOLD FIRE to steer the prowler towards your crosshair. The prowler will chase down the first enemy or terror trail it sees, and nearsight the enemy on impact.",
        displayIcon:
          "https://media.valorant-api.com/agents/dade69b4-4f5a-8528-247b-219e5a1facd6/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Nightfall",
        description:
          "EQUIP the power of nightmare itself. FIRE to unleash a wave of unstoppable nightmare energy. Enemies caught in the wave are marked by terror trails, deafened, and decayed.",
        displayIcon:
          "https://media.valorant-api.com/agents/dade69b4-4f5a-8528-247b-219e5a1facd6/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 2.578,
      maxDuration: 2.578,
      mediaList: [
        {
          id: 963067082,
          wwise: "https://media.valorant-api.com/sounds/963067082.wem",
          wave: "https://media.valorant-api.com/sounds/963067082.wav",
        },
      ],
    },
  },
  {
    uuid: "5f8d3a7f-467b-97f3-062c-13acf203c006",
    displayName: "Breach",
    description:
      "The bionic Swede Breach fires powerful, targeted kinetic blasts to aggressively clear a path through enemy ground. The damage and disruption he inflicts ensures no fight is ever fair.",
    developerName: "Breach",
    characterTags: null,
    displayIcon:
      "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/background.png",
    backgroundGradientColors: ["ff9c33ff", "b04621ff", "523a23ff", "44412eff"],
    assetPath: "ShooterGame/Content/Characters/Breach/Breach_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "1b47567f-8f7b-444b-aae3-b0c634622d10",
      displayName: "Initiator",
      description:
        "Initiators challenge angles by setting up their team to enter contested ground and push defenders away.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/1b47567f-8f7b-444b-aae3-b0c634622d10/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Breaker_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Flashpoint",
        description:
          "EQUIP a blinding charge. FIRE the charge to set a fast-acting burst through the wall. The charge detonates to blind all players looking at it.",
        displayIcon:
          "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Fault Line",
        description:
          "EQUIP a seismic blast. HOLD FIRE to increase the distance. RELEASE to set off the quake, dazing all players in its zone and in a line up to the zone.",
        displayIcon:
          "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Aftershock",
        description:
          "EQUIP a fusion charge. FIRE the charge to set a slow-acting burst through the wall. The burst does heavy damage to anyone caught in its area.",
        displayIcon:
          "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Rolling Thunder",
        description:
          "EQUIP a Seismic Charge. FIRE to send a cascading quake through all terrain in a large cone. The quake dazes and knocks up anyone caught in it.",
        displayIcon:
          "https://media.valorant-api.com/agents/5f8d3a7f-467b-97f3-062c-13acf203c006/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 2.456469,
      maxDuration: 2.456469,
      mediaList: [
        {
          id: 802792402,
          wwise: "https://media.valorant-api.com/sounds/802792402.wem",
          wave: "https://media.valorant-api.com/sounds/802792402.wav",
        },
      ],
    },
  },
  {
    uuid: "f94c3b30-42be-e959-889c-5aa313dba261",
    displayName: "Raze",
    description:
      'Raze explodes out of Brazil with her big personality and big guns. With her blunt-force-trauma playstyle, she excels at flushing entrenched enemies and clearing tight spaces with a generous dose of "boom".',
    developerName: "Clay",
    characterTags: ["Area Damage Specialist"],
    displayIcon:
      "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/background.png",
    backgroundGradientColors: ["feac45ff", "d64f35ff", "2c5942ff", "2b474bff"],
    assetPath: "ShooterGame/Content/Characters/Clay/Clay_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "dbe8757e-9e92-4ed4-b39f-9dfc589691d4",
      displayName: "Duelist",
      description:
        "Duelists are self-sufficient fraggers who their team expects, through abilities and skills, to get high frags and seek out engagements first.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/dbe8757e-9e92-4ed4-b39f-9dfc589691d4/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Assault_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Blast Pack",
        description:
          "INSTANTLY throw a Blast Pack that will stick to surfaces. RE-USE the ability after deployment to detonate, damaging and moving anything hit.",
        displayIcon:
          "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Paint Shells",
        description:
          "EQUIP a cluster grenade. FIRE to throw the grenade, which does damage and creates sub-munitions, each doing damage to anyone in their range. ALT FIRE to lob.",
        displayIcon:
          "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Boom Bot",
        description:
          "EQUIP a Boom Bot. FIRE will deploy the bot, causing it to travel in a straight line on the ground, bouncing off walls. The Boom Bot will lock on to any enemies in its frontal cone and chase them, exploding for heavy damage if it reaches them.",
        displayIcon:
          "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Showstopper",
        description:
          "EQUIP a rocket launcher. FIRE shoots a rocket that does massive area damage on contact with anything.",
        displayIcon:
          "https://media.valorant-api.com/agents/f94c3b30-42be-e959-889c-5aa313dba261/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 1.541198,
      maxDuration: 1.541198,
      mediaList: [
        {
          id: 632864455,
          wwise: "https://media.valorant-api.com/sounds/632864455.wem",
          wave: "https://media.valorant-api.com/sounds/632864455.wav",
        },
      ],
    },
  },
  {
    uuid: "22697a3d-45bf-8dd7-4fec-84a9e28c69d7",
    displayName: "Chamber",
    description:
      "Well dressed and well armed, French weapons designer Chamber expels aggressors with deadly precision. He leverages his custom arsenal to hold the line and pick off enemies from afar, with a contingency built for every plan.",
    developerName: "Deadeye",
    characterTags: null,
    displayIcon:
      "https://media.valorant-api.com/agents/22697a3d-45bf-8dd7-4fec-84a9e28c69d7/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/22697a3d-45bf-8dd7-4fec-84a9e28c69d7/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/22697a3d-45bf-8dd7-4fec-84a9e28c69d7/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/22697a3d-45bf-8dd7-4fec-84a9e28c69d7/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/22697a3d-45bf-8dd7-4fec-84a9e28c69d7/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/22697a3d-45bf-8dd7-4fec-84a9e28c69d7/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/22697a3d-45bf-8dd7-4fec-84a9e28c69d7/background.png",
    backgroundGradientColors: ["ffce6fff", "7b4d21ff", "372d2bff", "163555ff"],
    assetPath: "ShooterGame/Content/Characters/Deadeye/Deadeye_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "5fc02f99-4091-4486-a531-98459a3e95e9",
      displayName: "Sentinel",
      description:
        "Sentinels are defensive experts who can lock down areas and watch flanks, both on attacker and defender rounds.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/5fc02f99-4091-4486-a531-98459a3e95e9/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Sentinel_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability2",
        displayName: "Rendezvous",
        description:
          "PLACE a teleport anchor. While on the ground and in range of the anchor, REACTIVATE to quickly teleport to the anchor.  The anchor can be picked up to be REDEPLOYED.",
        displayIcon:
          "https://media.valorant-api.com/agents/22697a3d-45bf-8dd7-4fec-84a9e28c69d7/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Trademark",
        description:
          "PLACE a trap that scans for enemies. When a visible enemy comes in range, the trap counts down and then destabilizes the terrain around them, creating a lingering field that slows players caught inside of it. The trap can be picked up to be REDEPLOYED.",
        displayIcon:
          "https://media.valorant-api.com/agents/22697a3d-45bf-8dd7-4fec-84a9e28c69d7/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ability1",
        displayName: "Headhunter",
        description:
          "ACTIVATE to equip a heavy pistol. ALT FIRE with the pistol equipped to aim down sights.",
        displayIcon:
          "https://media.valorant-api.com/agents/22697a3d-45bf-8dd7-4fec-84a9e28c69d7/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Tour De Force",
        description:
          "ACTIVATE to summon a powerful, custom sniper rifle that will kill an enemy with any direct hit to the upper body.  Killing an enemy creates a lingering field that slows players caught inside of it.",
        displayIcon:
          "https://media.valorant-api.com/agents/22697a3d-45bf-8dd7-4fec-84a9e28c69d7/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 1.939385,
      maxDuration: 1.939385,
      mediaList: [
        {
          id: 765052468,
          wwise: "https://media.valorant-api.com/sounds/765052468.wem",
          wave: "https://media.valorant-api.com/sounds/765052468.wav",
        },
      ],
    },
  },
  {
    uuid: "601dbbe7-43ce-be57-2a40-4abd24953621",
    displayName: "KAY/O",
    description:
      "KAY/O is a machine of war built for a single purpose: neutralizing radiants. His power to suppress enemy abilities cripples his opponents' capacity to fight back, securing him and his allies the ultimate edge.",
    developerName: "Grenadier",
    characterTags: null,
    displayIcon:
      "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/background.png",
    backgroundGradientColors: ["4afaffff", "4da6e1ff", "1a1e4bff", "391a61ff"],
    assetPath:
      "ShooterGame/Content/Characters/Grenadier/Grenadier_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "1b47567f-8f7b-444b-aae3-b0c634622d10",
      displayName: "Initiator",
      description:
        "Initiators challenge angles by setting up their team to enter contested ground and push defenders away.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/1b47567f-8f7b-444b-aae3-b0c634622d10/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Breaker_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Grenade",
        displayName: "FRAG/ment",
        description:
          "EQUIP an explosive fragment. FIRE to throw. ALT FIRE to lob.The fragment sticks to the floor and explodes multiple times, dealing near lethal damage at the center with each explosion.",
        displayIcon:
          "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ability1",
        displayName: "FLASH/drive",
        description:
          "EQUIP a flash grenade. FIRE to overhand throw. ALT FIRE to underhand throw a weaker version that explodes quickly. The flash grenade explodes after a short fuse, blinding anyone in line of sight.",
        displayIcon:
          "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "ZERO/point",
        description:
          "EQUIP a suppression blade. FIRE to throw. The blade sticks to the first surface it hits, winds up, and suppresses anyone in the radius of the explosion.",
        displayIcon:
          "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/abilities/ability2/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "NULL/cmd",
        description:
          "INSTANTLY overload with polarized radianite energy that pulses from KAY/O in a massive radius. Enemies hit with pulses are suppressed for a short duration. While overloaded, KAY/O gains combat stim and can be re-stabilized if downed.",
        displayIcon:
          "https://media.valorant-api.com/agents/601dbbe7-43ce-be57-2a40-4abd24953621/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 1.034417,
      maxDuration: 1.034417,
      mediaList: [
        {
          id: 170847866,
          wwise: "https://media.valorant-api.com/sounds/170847866.wem",
          wave: "https://media.valorant-api.com/sounds/170847866.wav",
        },
      ],
    },
  },
  {
    uuid: "6f2a04ca-43e0-be17-7f36-b3908627744d",
    displayName: "Skye",
    description:
      "Hailing from Australia, Skye and her band of beasts trailblaze the way through hostile territory. With her creations hampering the enemy, and her power to heal others, the team is strongest and safest by Skye's side.",
    developerName: "Guide",
    characterTags: null,
    displayIcon:
      "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/background.png",
    backgroundGradientColors: ["94e789ff", "aa8a49ff", "4f1413ff", "314d48ff"],
    assetPath: "ShooterGame/Content/Characters/Guide/Guide_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "1b47567f-8f7b-444b-aae3-b0c634622d10",
      displayName: "Initiator",
      description:
        "Initiators challenge angles by setting up their team to enter contested ground and push defenders away.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/1b47567f-8f7b-444b-aae3-b0c634622d10/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Breaker_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Trailblazer",
        description:
          "EQUIP a Tasmanian tiger trinket. FIRE to send out and take control of the predator.  While in control, FIRE to leap forward, exploding in a concussive blast and damaging directly hit enemies.",
        displayIcon:
          "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Guiding Light",
        description:
          "EQUIP a hawk trinket.  FIRE to send it forward. HOLD FIRE to guide the hawk in the direction of your crosshair. RE-USE while the hawk is in flight to transform it into a flash. The flash reaches max potency after a short duration during the hawk's flight.",
        displayIcon:
          "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Regrowth",
        description:
          "EQUIP a healing trinket.  HOLD FIRE to channel, healing allies in range and line of sight.  Can be reused until her healing pool is depleted.  Skye cannot heal herself.",
        displayIcon:
          "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Seekers",
        description:
          "EQUIP a Seeker trinket.  FIRE to send out three Seekers to track down the three closest enemies.  If a Seeker reaches its target, it nearsights them.",
        displayIcon:
          "https://media.valorant-api.com/agents/6f2a04ca-43e0-be17-7f36-b3908627744d/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 1.807344,
      maxDuration: 1.807344,
      mediaList: [
        {
          id: 452875258,
          wwise: "https://media.valorant-api.com/sounds/452875258.wem",
          wave: "https://media.valorant-api.com/sounds/452875258.wav",
        },
      ],
    },
  },
  {
    uuid: "117ed9e3-49f3-6512-3ccf-0cada7e3823b",
    displayName: "Cypher",
    description:
      "The Moroccan information broker, Cypher is a one-man surveillance network who keeps tabs on the enemy's every move. No secret is safe. No maneuver goes unseen. Cypher is always watching.",
    developerName: "Gumshoe",
    characterTags: ["Detection", "Defensive Lockdown"],
    displayIcon:
      "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/background.png",
    backgroundGradientColors: ["db9b75ff", "4268b3ff", "3f3f6cff", "2b527cff"],
    assetPath: "ShooterGame/Content/Characters/Gumshoe/Gumshoe_PrimaryAsset",
    isFullPortraitRightFacing: true,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "5fc02f99-4091-4486-a531-98459a3e95e9",
      displayName: "Sentinel",
      description:
        "Sentinels are defensive experts who can lock down areas and watch flanks, both on attacker and defender rounds.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/5fc02f99-4091-4486-a531-98459a3e95e9/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Sentinel_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Cyber Cage",
        description:
          "INSTANTLY toss the cyber cage in front of Cypher. ACTIVATE to create a zone that blocks vision and plays an audio cue when enemies pass through it",
        displayIcon:
          "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Spycam",
        description:
          "EQUIP a spycam. FIRE to place the spycam at the targeted location. RE-USE this ability to take control of the camera's view. While in control of the camera, FIRE to shoot a marking dart. This dart will reveal the location of any player struck by the dart.",
        displayIcon:
          "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Trapwire",
        description:
          "EQUIP a trapwire. FIRE to place a destructible and covert tripwire at the targeted location, creating a line that spans between the placed location and the wall opposite. Enemy players who cross a tripwire will be tethered, revealed, and dazed after a short period if they do not destroy the device in time. This ability can be picked up to be REDEPLOYED.",
        displayIcon:
          "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Neural Theft",
        description:
          "INSTANTLY use on a targeted dead enemy to download information on their team.  After a brief delay, the location of all living enemy players will be revealed twice.",
        displayIcon:
          "https://media.valorant-api.com/agents/117ed9e3-49f3-6512-3ccf-0cada7e3823b/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 2.807927,
      maxDuration: 2.807927,
      mediaList: [
        {
          id: 246514732,
          wwise: "https://media.valorant-api.com/sounds/246514732.wem",
          wave: "https://media.valorant-api.com/sounds/246514732.wav",
        },
      ],
    },
  },
  {
    uuid: "320b2a48-4d9b-a075-30f1-1f93a9b638fa",
    displayName: "Sova",
    description:
      "Born from the eternal winter of Russia's tundra, Sova tracks, finds, and eliminates enemies with ruthless efficiency and precision. His custom bow and incredible scouting abilities ensure that even if you run, you cannot hide. ",
    developerName: "Hunter",
    characterTags: ["Detection", "Area Damage"],
    displayIcon:
      "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/background.png",
    backgroundGradientColors: ["f7c7a5ff", "392931ff", "101c47ff", "082652ff"],
    assetPath: "ShooterGame/Content/Characters/Hunter/Hunter_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: true,
    role: {
      uuid: "1b47567f-8f7b-444b-aae3-b0c634622d10",
      displayName: "Initiator",
      description:
        "Initiators challenge angles by setting up their team to enter contested ground and push defenders away.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/1b47567f-8f7b-444b-aae3-b0c634622d10/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Breaker_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Shock Bolt",
        description:
          "EQUIP a bow with a shock bolt. FIRE to send the explosive bolt forward, detonating upon collision and damaging players nearby. HOLD FIRE to extend the range of the projectile. ALTERNATE FIRE to add up to two bounces to this arrow.",
        displayIcon:
          "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Recon Bolt",
        description:
          "EQUIP a bow with recon bolt. FIRE to send the recon bolt forward, activating upon collision and revealing the location of nearby enemies caught in the line of sight of the bolt. Enemies can destroy this bolt. HOLD FIRE to extend the range of the projectile. ALTERNATE FIRE to add up to two bounces to this arrow. ",
        displayIcon:
          "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Owl Drone",
        description:
          "EQUIP an owl drone. FIRE to deploy and take control of movement of the drone. While in control of the drone, FIRE to shoot a marking dart. This dart will reveal the location of any player struck by the dart.",
        displayIcon:
          "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Hunter's Fury",
        description:
          "EQUIP a bow with three long-range, wall-piercing energy blasts. FIRE to release an energy blast in a line in front of Sova, dealing damage and revealing the location of enemies caught in the line. This ability can be RE-USED up to two more times while the ability timer is active.",
        displayIcon:
          "https://media.valorant-api.com/agents/320b2a48-4d9b-a075-30f1-1f93a9b638fa/abilities/ultimate/displayicon.png",
      },
      {
        slot: "Passive",
        displayName: "Uncanny Marksman",
        description:
          "Sova's custom bow can fire his arrows and bounce them off terrain. Holding fire charges the bow's power, and the bolt is loosed when released. Press alt fire to change the number of bounces.Your arrows can bounce off terrain. Holding left click increases the bow's range trajectory. Right clicking Toggle through the desired number of terrain bounces by right clicking. The arrow is loosed when left click is released.",
        displayIcon: null,
      },
    ],
    voiceLine: {
      minDuration: 2.021729,
      maxDuration: 2.021729,
      mediaList: [
        {
          id: 130865070,
          wwise: "https://media.valorant-api.com/sounds/130865070.wem",
          wave: "https://media.valorant-api.com/sounds/130865070.wav",
        },
      ],
    },
  },
  {
    uuid: "1e58de9c-4950-5125-93e9-a0aee9f98746",
    displayName: "Killjoy",
    description:
      "The genius of Germany, Killjoy secures and defends key battlefield positions with a collection of traps, turrets, and mines. Each invention is primed to punish any assailant too dumb to back down.",
    developerName: "Killjoy",
    characterTags: ["Defensive Lockdown", "Area Damage"],
    displayIcon:
      "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/background.png",
    backgroundGradientColors: ["ffc300ff", "b87b00ff", "413950ff", "614414ff"],
    assetPath: "ShooterGame/Content/Characters/Killjoy/Killjoy_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "5fc02f99-4091-4486-a531-98459a3e95e9",
      displayName: "Sentinel",
      description:
        "Sentinels are defensive experts who can lock down areas and watch flanks, both on attacker and defender rounds.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/5fc02f99-4091-4486-a531-98459a3e95e9/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Sentinel_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Grenade",
        displayName: "Nanoswarm",
        description:
          "EQUIP a Nanoswarm grenade. FIRE to throw the grenade. Upon landing, the Nanoswarm goes covert. ALT FIRE to lob. ACTIVATE the Nanoswarm to deploy a damaging swarm of nanobots.  ",
        displayIcon:
          "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ability1",
        displayName: "ALARMBOT",
        description:
          "EQUIP a covert Alarmbot. FIRE to deploy a bot that hunts down enemies that get in range.  After reaching its target, the bot explodes and applies Vulnerable to enemies in the area. HOLD EQUIP to recall a deployed bot.",
        displayIcon:
          "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "TURRET",
        description:
          "EQUIP a Turret. FIRE to deploy a turret that fires at enemies in a 180 degree cone. ALT FIRE to swap turret direction. HOLD EQUIP to recall the deployed turret. ",
        displayIcon:
          "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/abilities/ability2/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Lockdown",
        description:
          "EQUIP the Lockdown device. FIRE to deploy the device. After a long windup, the device Detains all enemies caught in the radius. The device can be destroyed by enemies.",
        displayIcon:
          "https://media.valorant-api.com/agents/1e58de9c-4950-5125-93e9-a0aee9f98746/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 2.689708,
      maxDuration: 2.689708,
      mediaList: [
        {
          id: 1062625853,
          wwise: "https://media.valorant-api.com/sounds/1062625853.wem",
          wave: "https://media.valorant-api.com/sounds/1062625853.wav",
        },
      ],
    },
  },
  {
    uuid: "95b78ed7-4637-86d9-7e41-71ba8c293152",
    displayName: "Harbor",
    description:
      "Hailing from India’s coast, Harbor storms the field wielding ancient technology with dominion over water. He unleashes frothing rapids and crushing waves to shield his allies and to pummel those that oppose him.",
    developerName: "Mage",
    characterTags: null,
    displayIcon:
      "https://media.valorant-api.com/agents/95b78ed7-4637-86d9-7e41-71ba8c293152/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/95b78ed7-4637-86d9-7e41-71ba8c293152/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/95b78ed7-4637-86d9-7e41-71ba8c293152/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/95b78ed7-4637-86d9-7e41-71ba8c293152/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/95b78ed7-4637-86d9-7e41-71ba8c293152/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/95b78ed7-4637-86d9-7e41-71ba8c293152/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/95b78ed7-4637-86d9-7e41-71ba8c293152/background.png",
    backgroundGradientColors: ["f2d6a3ff", "136c6bff", "11434eff", "0c262cff"],
    assetPath: "ShooterGame/Content/Characters/Mage/Mage_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "4ee40330-ecdd-4f2f-98a8-eb1243428373",
      displayName: "Controller",
      description:
        "Controllers are experts in slicing up dangerous territory to set their team up for success.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/4ee40330-ecdd-4f2f-98a8-eb1243428373/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Strategist_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Cove",
        description:
          "EQUIP a sphere of shielding water. FIRE to throw. ALT FIRE to underhand throw. Upon impacting the ground, spawn a destructible water shield that blocks bullets.",
        displayIcon:
          "https://media.valorant-api.com/agents/95b78ed7-4637-86d9-7e41-71ba8c293152/abilities/ability1/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Cascade",
        description:
          "EQUIP a wave of water. FIRE to send the wave rolling forward and through walls. RE-USE to stop the wave. Players hit are SLOWED.",
        displayIcon:
          "https://media.valorant-api.com/agents/95b78ed7-4637-86d9-7e41-71ba8c293152/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "High Tide",
        description:
          "EQUIP a wall of water. FIRE to send the water forward along the ground. HOLD FIRE to guide the water in the direction of your crosshair, passing through the world, spawning a wall along the water’s path. ALT FIRE while bending to stop the water early. Players hit are SLOWED.",
        displayIcon:
          "https://media.valorant-api.com/agents/95b78ed7-4637-86d9-7e41-71ba8c293152/abilities/ability2/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Reckoning",
        description:
          "EQUIP the full power of your Artifact. FIRE to summon a geyser pool on the ground. Enemy players in the area are targeted by successive geyser strikes. Players caught within a strike are CONCUSSED.",
        displayIcon:
          "https://media.valorant-api.com/agents/95b78ed7-4637-86d9-7e41-71ba8c293152/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 1.554083,
      maxDuration: 1.554083,
      mediaList: [
        {
          id: 409447225,
          wwise: "https://media.valorant-api.com/sounds/409447225.wem",
          wave: "https://media.valorant-api.com/sounds/409447225.wav",
        },
      ],
    },
  },
  {
    uuid: "707eab51-4836-f488-046a-cda6bf494859",
    displayName: "Viper",
    description:
      "The American Chemist, Viper deploys an array of poisonous chemical devices to control the battlefield and cripple the enemy's vision. If the toxins don't kill her prey, her mindgames surely will.",
    developerName: "Pandemic",
    characterTags: ["Vision Control Specialist"],
    displayIcon:
      "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/background.png",
    backgroundGradientColors: ["89f476ff", "347334ff", "2c4f5eff", "493a7cff"],
    assetPath: "ShooterGame/Content/Characters/Pandemic/Pandemic_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "4ee40330-ecdd-4f2f-98a8-eb1243428373",
      displayName: "Controller",
      description:
        "Controllers are experts in slicing up dangerous territory to set their team up for success.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/4ee40330-ecdd-4f2f-98a8-eb1243428373/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Strategist_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Poison Cloud",
        description:
          "EQUIP a gas emitter. FIRE to throw the emitter that perpetually remains throughout the round. ALT FIRE to lob. RE-USE the ability to create a toxic gas cloud at the cost of fuel. This ability can be RE-USED more than once and can be picked up to be REDEPLOYED.",
        displayIcon:
          "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Toxic Screen",
        description:
          "EQUIP a gas emitter launcher that penetrates terrain. FIRE to deploy a long line of gas emitters. RE-USE the ability to create a tall wall of toxic gas at the cost of fuel. This ability can be RE-USED more than once.",
        displayIcon:
          "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Snake Bite",
        description:
          "EQUIP a chemical launcher. FIRE to launch a canister that shatters upon hitting the floor, creating a lingering chemical zone that damages and applies Vulnerable.",
        displayIcon:
          "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Viper's Pit",
        description:
          "EQUIP a chemical sprayer. FIRE to spray a chemical cloud in all directions around Viper, creating a large cloud that reduces the vision range of players and maximum health of enemies inside of it. HOLD the ability key to disperse the cloud early.",
        displayIcon:
          "https://media.valorant-api.com/agents/707eab51-4836-f488-046a-cda6bf494859/abilities/ultimate/displayicon.png",
      },
      {
        slot: "Passive",
        displayName: "Toxic",
        description:
          "You gradually generate and replenish the toxin that fuels your abilities.  Enemies that cross through Viper's Poison Cloud, Toxic Screen, or Viper's Pit are instantly inflicted with at least 50 decay. Their decay level increases the longer they remain in contact with it.",
        displayIcon: null,
      },
    ],
    voiceLine: {
      minDuration: 2.445958,
      maxDuration: 2.445958,
      mediaList: [
        {
          id: 204662687,
          wwise: "https://media.valorant-api.com/sounds/204662687.wem",
          wave: "https://media.valorant-api.com/sounds/204662687.wav",
        },
      ],
    },
  },
  {
    uuid: "eb93336a-449b-9c1b-0a54-a891f7921d69",
    displayName: "Phoenix",
    description:
      "Hailing from the U.K., Phoenix's star power shines through in his fighting style, igniting the battlefield with flash and flare. Whether he's got backup or not, he's rushing in to fight on his own terms.",
    developerName: "Phoenix",
    characterTags: ["Flexibility", "Self-Sustain"],
    displayIcon:
      "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/background.png",
    backgroundGradientColors: ["f7bf60ff", "ea6d4eff", "262423ff", "363b42ff"],
    assetPath: "ShooterGame/Content/Characters/Phoenix/Phoenix_PrimaryAsset",
    isFullPortraitRightFacing: true,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: true,
    role: {
      uuid: "dbe8757e-9e92-4ed4-b39f-9dfc589691d4",
      displayName: "Duelist",
      description:
        "Duelists are self-sufficient fraggers who their team expects, through abilities and skills, to get high frags and seek out engagements first.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/dbe8757e-9e92-4ed4-b39f-9dfc589691d4/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Assault_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Grenade",
        displayName: "Blaze",
        description:
          "EQUIP a flame wall. FIRE to create a line of flame that moves forward, creating a wall of fire that blocks vision and damages players passing through it. HOLD FIRE to bend the wall in the direction of your crosshair.",
        displayIcon:
          "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ability1",
        displayName: "Curveball",
        description:
          "EQUIP a flare orb that takes a curving path and detonates shortly after throwing. FIRE to curve the flare orb to the left, detonating and blinding any player who sees the orb. ALT FIRE to curve the flare orb to the right.",
        displayIcon:
          "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Hot Hands",
        description:
          "EQUIP a fireball. FIRE to throw a fireball that explodes after a set amount of time or upon hitting the ground, creating a lingering fire zone that damages enemies. ALT FIRE to lob.",
        displayIcon:
          "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/abilities/ability2/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Run it Back",
        description:
          "INSTANTLY place a marker at Phoenix's location. While this ability is active, dying or allowing the timer to expire will end this ability and bring Phoenix back to this location with full health and the amount of armor he had when the ability was cast.",
        displayIcon:
          "https://media.valorant-api.com/agents/eb93336a-449b-9c1b-0a54-a891f7921d69/abilities/ultimate/displayicon.png",
      },
      {
        slot: "Passive",
        displayName: "Heating Up",
        description:
          "PASSIVELY heal Phoenix instead of taking damage when standing in Phoenix's own fire",
        displayIcon: null,
      },
    ],
    voiceLine: {
      minDuration: 2.258333,
      maxDuration: 2.258333,
      mediaList: [
        {
          id: 384959611,
          wwise: "https://media.valorant-api.com/sounds/384959611.wem",
          wave: "https://media.valorant-api.com/sounds/384959611.wav",
        },
      ],
    },
  },
  {
    uuid: "41fb69c1-4189-7b37-f117-bcaf1e96f1bf",
    displayName: "Astra",
    description:
      "Ghanaian Agent Astra harnesses the energies of the cosmos to reshape battlefields to her whim. With full command of her astral form and a talent for deep strategic foresight, she's always eons ahead of her enemy's next move.",
    developerName: "Rift",
    characterTags: null,
    displayIcon:
      "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/background.png",
    backgroundGradientColors: ["f47dc9ff", "a54498ff", "5210c6ff", "372518ff"],
    assetPath: "ShooterGame/Content/Characters/Rift/Rift_PrimaryAsset",
    isFullPortraitRightFacing: true,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "4ee40330-ecdd-4f2f-98a8-eb1243428373",
      displayName: "Controller",
      description:
        "Controllers are experts in slicing up dangerous territory to set their team up for success.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/4ee40330-ecdd-4f2f-98a8-eb1243428373/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Strategist_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Nova Pulse",
        description:
          "Place Stars in Astral Form (Ultimate Key).\r\n\r\nACTIVATE a Star to detonate a Nova Pulse. The Nova Pulse charges briefly then strikes, concussing all players in its area.",
        displayIcon:
          "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Nebula  / Dissipate",
        description:
          "Place Stars in Astral Form (Ultimate Key). \r\n\r\nACTIVATE a Star to transform it into a Nebula (smoke).\r\n\r\nUSE a Star to Dissipate it, returning the star to be placed in a new location after a delay.\r\n\r\nDissipate briefly forms a fake Nebula at the Star's location before returning.",
        displayIcon:
          "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Gravity Well",
        description:
          "Place Stars in Astral Form (Ultimate Key).\r\n\r\nACTIVATE a Star to form a Gravity Well. Players in the area are pulled toward the center before it explodes, making all players still trapped inside vulnerable.",
        displayIcon:
          "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Astral Form / Cosmic Divide",
        description:
          "ACTIVATE to enter Astral Form where you can place Stars with PRIMARY FIRE. Stars can be reactivated later, transforming them into a Nova Pulse, Nebula, or Gravity Well.\r\n\r\nWhen Cosmic Divide is charged, use SECONDARY FIRE in Astral Form to begin aiming it, then PRIMARY FIRE to select two locations. An infinite Cosmic Divide connects the two points you select. Cosmic Divide blocks bullets and heavily dampens audio.",
        displayIcon:
          "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/abilities/ultimate/displayicon.png",
      },
      {
        slot: "Passive",
        displayName: "Astral Form",
        description:
          "ACTIVATE Ultimate to enter Astral Form and PRIMARY FIRE to place Stars. Target Stars with your Nova Pulse, Nebula, or Gravity Well to use those abilities.",
        displayIcon:
          "https://media.valorant-api.com/agents/41fb69c1-4189-7b37-f117-bcaf1e96f1bf/abilities/passive/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 3.18301,
      maxDuration: 3.18301,
      mediaList: [
        {
          id: 594322343,
          wwise: "https://media.valorant-api.com/sounds/594322343.wem",
          wave: "https://media.valorant-api.com/sounds/594322343.wav",
        },
      ],
    },
  },
  {
    uuid: "9f0d8ba9-4140-b941-57d3-a7ad57c6b417",
    displayName: "Brimstone",
    description:
      "Joining from the USA, Brimstone's orbital arsenal ensures his squad always has the advantage. His ability to deliver utility precisely and safely make him the unmatched boots-on-the-ground commander.  ",
    developerName: "Sarge",
    characterTags: ["Vision Control", "Area Damage"],
    displayIcon:
      "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/background.png",
    backgroundGradientColors: ["eb953fff", "892c1bff", "211d21ff", "282b38ff"],
    assetPath: "ShooterGame/Content/Characters/Sarge/Sarge_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: true,
    role: {
      uuid: "4ee40330-ecdd-4f2f-98a8-eb1243428373",
      displayName: "Controller",
      description:
        "Controllers are experts in slicing up dangerous territory to set their team up for success.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/4ee40330-ecdd-4f2f-98a8-eb1243428373/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Strategist_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Grenade",
        displayName: "Stim Beacon",
        description:
          "INSTANTLY toss down a stim beacon. Upon landing, it creates a field that grants players RapidFire and a speed boost.",
        displayIcon:
          "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ability1",
        displayName: "Incendiary",
        description:
          "EQUIP an incendiary grenade launcher. FIRE to launch a grenade that detonates as it comes to a rest on the floor, creating a lingering fire zone that damages players within the zone.",
        displayIcon:
          "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Sky Smoke",
        description:
          "EQUIP a tactical map. FIRE to set locations where Brimstone's smoke clouds will land. ALTERNATE FIRE to confirm, launching long-lasting smoke clouds that block vision in the selected area.",
        displayIcon:
          "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/abilities/ability2/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Orbital Strike",
        description:
          "EQUIP a tactical map. FIRE to launch a lingering orbital strike laser at the selected location, dealing high damage-over-time to players caught in the selected area.",
        displayIcon:
          "https://media.valorant-api.com/agents/9f0d8ba9-4140-b941-57d3-a7ad57c6b417/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 4.969511,
      maxDuration: 4.969511,
      mediaList: [
        {
          id: 421554800,
          wwise: "https://media.valorant-api.com/sounds/421554800.wem",
          wave: "https://media.valorant-api.com/sounds/421554800.wav",
        },
      ],
    },
  },
  {
    uuid: "bb2a4828-46eb-8cd1-e765-15848195d751",
    displayName: "Neon",
    description:
      "Filipino Agent Neon surges forward at shocking speeds, discharging bursts of bioelectric radiance as fast as her body generates it. She races ahead to catch enemies off guard then strikes them down quicker than lightning.",
    developerName: "Sprinter",
    characterTags: null,
    displayIcon:
      "https://media.valorant-api.com/agents/bb2a4828-46eb-8cd1-e765-15848195d751/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/bb2a4828-46eb-8cd1-e765-15848195d751/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/bb2a4828-46eb-8cd1-e765-15848195d751/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/bb2a4828-46eb-8cd1-e765-15848195d751/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/bb2a4828-46eb-8cd1-e765-15848195d751/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/bb2a4828-46eb-8cd1-e765-15848195d751/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/bb2a4828-46eb-8cd1-e765-15848195d751/background.png",
    backgroundGradientColors: ["ba89ffff", "6241ccff", "38328eff", "2c4799ff"],
    assetPath: "ShooterGame/Content/Characters/Sprinter/Sprinter_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "dbe8757e-9e92-4ed4-b39f-9dfc589691d4",
      displayName: "Duelist",
      description:
        "Duelists are self-sufficient fraggers who their team expects, through abilities and skills, to get high frags and seek out engagements first.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/dbe8757e-9e92-4ed4-b39f-9dfc589691d4/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Assault_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability2",
        displayName: "High Gear",
        description:
          "INSTANTLY channel Neon’s power for increased speed. When charged, ALT FIRE to trigger an electric slide. Slide charge resets every two kills.",
        displayIcon:
          "https://media.valorant-api.com/agents/bb2a4828-46eb-8cd1-e765-15848195d751/abilities/ability2/displayicon.png",
      },
      {
        slot: "Ability1",
        displayName: "Relay Bolt",
        description:
          "INSTANTLY throw an energy bolt that bounces once. Upon hitting each surface, the bolt electrifies the ground below with a concussive blast.",
        displayIcon:
          "https://media.valorant-api.com/agents/bb2a4828-46eb-8cd1-e765-15848195d751/abilities/ability1/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Fast Lane",
        description:
          "FIRE two energy lines forward on the ground that extend a short distance or until they hit a surface. The lines rise into walls of static electricity that block vision.",
        displayIcon:
          "https://media.valorant-api.com/agents/bb2a4828-46eb-8cd1-e765-15848195d751/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Overdrive",
        description:
          "Unleash Neon’s full power and speed for a short duration. FIRE to channel the power into a deadly lightning beam with high movement accuracy.",
        displayIcon:
          "https://media.valorant-api.com/agents/bb2a4828-46eb-8cd1-e765-15848195d751/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 1.26851,
      maxDuration: 1.26851,
      mediaList: [
        {
          id: 5690468,
          wwise: "https://media.valorant-api.com/sounds/5690468.wem",
          wave: "https://media.valorant-api.com/sounds/5690468.wav",
        },
      ],
    },
  },
  {
    uuid: "7f94d92c-4234-0a36-9646-3a87eb8b5c89",
    displayName: "Yoru",
    description:
      "Japanese native Yoru rips holes straight through reality to infiltrate enemy lines unseen. Using deception and aggression in equal measure, he gets the drop on each target before they know where to look.",
    developerName: "Stealth",
    characterTags: null,
    displayIcon:
      "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/background.png",
    backgroundGradientColors: ["66a8ffff", "3b37a7ff", "261e4fff", "101042ff"],
    assetPath: "ShooterGame/Content/Characters/Stealth/Stealth_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "dbe8757e-9e92-4ed4-b39f-9dfc589691d4",
      displayName: "Duelist",
      description:
        "Duelists are self-sufficient fraggers who their team expects, through abilities and skills, to get high frags and seek out engagements first.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/dbe8757e-9e92-4ed4-b39f-9dfc589691d4/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Assault_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Grenade",
        displayName: "FAKEOUT",
        description:
          "EQUIP an echo that transforms into a mirror image of Yoru when activated. FIRE to instantly activate the mirror image and send it forward. ALT FIRE to place an inactive echo. USE to transform an inactive echo into a mirror image and send it forward.  Mirror images explode in a blinding flash when destroyed by enemies.",
        displayIcon:
          "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ability1",
        displayName: "BLINDSIDE",
        description:
          "EQUIP to rip an unstable dimensional fragment from reality. FIRE to throw the fragment, activating a flash that winds up once it collides with a hard surface in world.",
        displayIcon:
          "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "GATECRASH",
        description:
          "EQUIP a rift tether FIRE to send the tether forward ALT FIRE to place a stationary tether ACTIVATE to teleport to the tether's location USE to trigger a fake teleport.",
        displayIcon:
          "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/abilities/ability2/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "DIMENSIONAL DRIFT",
        description:
          "EQUIP a mask that can see between dimensions. FIRE to drift into Yoru's dimension, unable to be affected or seen by enemies from the outside.",
        displayIcon:
          "https://media.valorant-api.com/agents/7f94d92c-4234-0a36-9646-3a87eb8b5c89/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 4.105177,
      maxDuration: 4.105177,
      mediaList: [
        {
          id: 107320642,
          wwise: "https://media.valorant-api.com/sounds/107320642.wem",
          wave: "https://media.valorant-api.com/sounds/107320642.wav",
        },
      ],
    },
  },
  {
    uuid: "569fdd95-4d10-43ab-ca70-79becc718b46",
    displayName: "Sage",
    description:
      "The bastion of China, Sage creates safety for herself and her team wherever she goes. Able to revive fallen friends and stave off forceful assaults, she provides a calm center to a hellish battlefield.",
    developerName: "Thorne",
    characterTags: ["Recovery", "Stalling"],
    displayIcon:
      "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/background.png",
    backgroundGradientColors: ["7bfedeff", "41819aff", "102d23ff", "226071ff"],
    assetPath: "ShooterGame/Content/Characters/Thorne/Thorne_PrimaryAsset",
    isFullPortraitRightFacing: true,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: true,
    role: {
      uuid: "5fc02f99-4091-4486-a531-98459a3e95e9",
      displayName: "Sentinel",
      description:
        "Sentinels are defensive experts who can lock down areas and watch flanks, both on attacker and defender rounds.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/5fc02f99-4091-4486-a531-98459a3e95e9/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Sentinel_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Slow Orb",
        description:
          "EQUIP a slowing orb. FIRE to throw a slowing orb forward that detonates upon landing, creating a lingering field that slows players caught inside of it.",
        displayIcon:
          "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Healing Orb",
        description:
          "EQUIP a healing orb. FIRE with your crosshairs over a damaged ally to activate a heal-over-time on them. ALT FIRE while Sage is damaged to activate a self heal-over-time.",
        displayIcon:
          "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Barrier Orb",
        description:
          "EQUIP a barrier orb. FIRE places a wall that fortifies after a few seconds. ALT FIRE rotates the targeter.",
        displayIcon:
          "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Resurrection",
        description:
          "EQUIP a resurrection ability. FIRE with your crosshairs placed over a dead ally to begin resurrecting them. After a brief channel, the ally will be brought back to life with full health.",
        displayIcon:
          "https://media.valorant-api.com/agents/569fdd95-4d10-43ab-ca70-79becc718b46/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 2.07,
      maxDuration: 2.07,
      mediaList: [
        {
          id: 119342169,
          wwise: "https://media.valorant-api.com/sounds/119342169.wem",
          wave: "https://media.valorant-api.com/sounds/119342169.wav",
        },
      ],
    },
  },
  {
    uuid: "a3bfb853-43b2-7238-a4f1-ad90e9e46bcc",
    displayName: "Reyna",
    description:
      "Forged in the heart of Mexico, Reyna dominates single combat, popping off with each kill she scores. Her capability is only limited by her raw skill, making her sharply dependant on performance. ",
    developerName: "Vampire",
    characterTags: ["Evasion", "Self-Sustain"],
    displayIcon:
      "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/background.png",
    backgroundGradientColors: ["e46e77ff", "c44d9fff", "2f2664ff", "2f203fff"],
    assetPath: "ShooterGame/Content/Characters/Vampire/Vampire_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "dbe8757e-9e92-4ed4-b39f-9dfc589691d4",
      displayName: "Duelist",
      description:
        "Duelists are self-sufficient fraggers who their team expects, through abilities and skills, to get high frags and seek out engagements first.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/dbe8757e-9e92-4ed4-b39f-9dfc589691d4/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Assault_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Devour",
        description:
          "Soul Harvest: Enemies that die to Reyna, or die within 3 seconds of taking damage from Reyna, leave behind Soul Orbs that last 3 seconds.\r\nDevour: INSTANTLY consume a nearby soul orb, rapidly healing for a short duration. Health gained through this skill exceeding 100 will decay over time. If EMPRESS is active, this skill will automatically cast and not consume the Soul Orb.",
        displayIcon:
          "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Dismiss",
        description:
          "INSTANTLY consume a nearby Soul Orb, becoming intangible for a short duration. If EMPRESS is active, also become invisible.",
        displayIcon:
          "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Leer",
        description:
          "EQUIP an ethereal, destructible eye. ACTIVATE to cast the eye a short distance forward. The eye will Nearsight all enemies who look at it.",
        displayIcon:
          "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Empress",
        description:
          "INSTANTLY enter a frenzy, increasing firing, equip and reload speed dramatically. Gain infinite charges of Soul Harvest abilities. When an enemy dies to Reyna, or dies within 3 seconds of taking damage from Reyna, the duration is renewed.",
        displayIcon:
          "https://media.valorant-api.com/agents/a3bfb853-43b2-7238-a4f1-ad90e9e46bcc/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 3.430208,
      maxDuration: 3.430208,
      mediaList: [
        {
          id: 847719523,
          wwise: "https://media.valorant-api.com/sounds/847719523.wem",
          wave: "https://media.valorant-api.com/sounds/847719523.wav",
        },
      ],
    },
  },
  {
    uuid: "8e253930-4c05-31dd-1b6c-968525494517",
    displayName: "Omen",
    description:
      "A phantom of a memory, Omen hunts in the shadows. He renders enemies blind, teleports across the field, then lets paranoia take hold as his foe scrambles to uncover where he might strike next.",
    developerName: "Wraith",
    characterTags: ["Mobility", "Vision Control"],
    displayIcon:
      "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/background.png",
    backgroundGradientColors: ["2fdddeff", "4f53afff", "344673ff", "193b3dff"],
    assetPath: "ShooterGame/Content/Characters/Wraith/Wraith_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: false,
    role: {
      uuid: "4ee40330-ecdd-4f2f-98a8-eb1243428373",
      displayName: "Controller",
      description:
        "Controllers are experts in slicing up dangerous territory to set their team up for success.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/4ee40330-ecdd-4f2f-98a8-eb1243428373/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Strategist_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Paranoia",
        description:
          "EQUIP a blinding orb.  FIRE to throw it forward, briefly reducing the vision range and deafening all players it touches. This projectile can pass straight through walls.",
        displayIcon:
          "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Dark Cover",
        description:
          "EQUIP a shadow orb, entering a phased world to place and target the orbs. PRESS the ability key to throw the shadow orb to the marked location, creating a long-lasting shadow sphere that blocks vision. HOLD FIRE while targeting to move the marker further away. HOLD SECONDARY FIRE while targeting to move the marker closer. PRESS RELOAD to toggle normal targeting view.",
        displayIcon:
          "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Shrouded Step",
        description:
          "EQUIP a shrouded step ability and see its range indicator. FIRE to begin a brief channel, then teleport to the marked location.",
        displayIcon:
          "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "From the Shadows",
        description:
          "EQUIP a tactical map. FIRE to begin teleporting to the selected location. While teleporting, Omen will appear as a Shade that can be destroyed by an enemy to cancel his teleport, or PRESS EQUIP for Omen to cancel his teleport.",
        displayIcon:
          "https://media.valorant-api.com/agents/8e253930-4c05-31dd-1b6c-968525494517/abilities/ultimate/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 3.758667,
      maxDuration: 3.758667,
      mediaList: [
        {
          id: 717842149,
          wwise: "https://media.valorant-api.com/sounds/717842149.wem",
          wave: "https://media.valorant-api.com/sounds/717842149.wav",
        },
      ],
    },
  },
  {
    uuid: "add6443a-41bd-e414-f6ad-e58d267f4e95",
    displayName: "Jett",
    description:
      "Representing her home country of South Korea, Jett's agile and evasive fighting style lets her take risks no one else can. She runs circles around every skirmish, cutting enemies up before they even know what hit them.",
    developerName: "Wushu",
    characterTags: ["Evasion", "Mobility"],
    displayIcon:
      "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/displayicon.png",
    displayIconSmall:
      "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/displayiconsmall.png",
    bustPortrait:
      "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/fullportrait.png",
    fullPortrait:
      "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/fullportrait.png",
    fullPortraitV2:
      "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/fullportrait.png",
    killfeedPortrait:
      "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/killfeedportrait.png",
    background:
      "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/background.png",
    backgroundGradientColors: ["90e3fdff", "557f8cff", "2b4e7cff", "1e3344ff"],
    assetPath: "ShooterGame/Content/Characters/Wushu/Wushu_PrimaryAsset",
    isFullPortraitRightFacing: false,
    isPlayableCharacter: true,
    isAvailableForTest: true,
    isBaseContent: true,
    role: {
      uuid: "dbe8757e-9e92-4ed4-b39f-9dfc589691d4",
      displayName: "Duelist",
      description:
        "Duelists are self-sufficient fraggers who their team expects, through abilities and skills, to get high frags and seek out engagements first.",
      displayIcon:
        "https://media.valorant-api.com/agents/roles/dbe8757e-9e92-4ed4-b39f-9dfc589691d4/displayicon.png",
      assetPath:
        "ShooterGame/Content/Characters/_Core/Roles/Assault_PrimaryDataAsset",
    },
    abilities: [
      {
        slot: "Ability1",
        displayName: "Updraft",
        description: "INSTANTLY propel Jett high into the air.",
        displayIcon:
          "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/abilities/ability1/displayicon.png",
      },
      {
        slot: "Ability2",
        displayName: "Tailwind",
        description:
          "ACTIVATE to prepare a gust of wind for a limited time. RE-USE the wind to propel Jett in the direction she is moving. If Jett is standing still, she propels forward.",
        displayIcon:
          "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/abilities/ability2/displayicon.png",
      },
      {
        slot: "Grenade",
        displayName: "Cloudburst",
        description:
          "INSTANTLY throw a projectile that expands into a brief vision-blocking cloud on impact with a surface. HOLD the ability key to curve the smoke in the direction of your crosshair.",
        displayIcon:
          "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/abilities/grenade/displayicon.png",
      },
      {
        slot: "Ultimate",
        displayName: "Blade Storm",
        description:
          "EQUIP a set of highly accurate throwing knives. FIRE to throw a single knife and recharge knives on a kill. ALTERNATE FIRE to throw all remaining daggers but does not recharge on a kill.",
        displayIcon:
          "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/abilities/ultimate/displayicon.png",
      },
      {
        slot: "Passive",
        displayName: "Drift",
        description:
          "Holding the jump button while falling allows you to glide through the air.",
        displayIcon:
          "https://media.valorant-api.com/agents/add6443a-41bd-e414-f6ad-e58d267f4e95/abilities/passive/displayicon.png",
      },
    ],
    voiceLine: {
      minDuration: 1.048729,
      maxDuration: 1.048729,
      mediaList: [
        {
          id: 878055936,
          wwise: "https://media.valorant-api.com/sounds/878055936.wem",
          wave: "https://media.valorant-api.com/sounds/878055936.wav",
        },
      ],
    },
  },
];
